/**
 * Model for topic response campaign
 */
define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  "use strict";

  const TopicResponseCampaignModel = {};

  TopicResponseCampaignModel.topicResponseCampaign = Backbone.Model.extend({
    idAttribute: "respTempId",
    defaults: {
      respTempId: 0,
      rootIntentId: 0,
      campaignId: 0,
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/${this.get(
        "rootIntentId",
      )}/responses/templates/${this.get("respTempId")}/campaign/${this.get("campaignId")}`;
    },
  });

  TopicResponseCampaignModel.topicResponseCampaigns = Backbone.Collection.extend({
    model: TopicResponseCampaignModel.topicResponseCampaign,
    addResponseCampaign: function (attributes) {
      const newCampaign = new TopicResponseCampaignModel.topicResponseCampaign();
      newCampaign.set(attributes);
      this.add(newCampaign);
      return newCampaign;
    },
  });

  return TopicResponseCampaignModel;
});
